<template>
  <div class="about">
    <div class="bg-img-header">
      <img src="/img/about.jpg" width="100%" />
    </div>

    <div class="relative item" v-if="!loading">
      <v-container>
        <v-row class="align-center" v-if="item">
          <v-col
            cols="12"
            md="6"
            v-if="item.img"
            class="mt-6 mt-md-12 pr-3 pr-md-16"
          >
            <img
              loading="lazy"
              :src="files + item.img + `?resize=1&w=960`"
              :alt="item.title"
              class="featured-img"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
            v-if="item.title || item.text"
            class="mt-6 mt-md-12"
          >
            <div class="white--text font-weight-black item-title">
              {{ item.title }}
            </div>

            <div
              class="white--text font-weight-regular mt-6 item-text"
              v-if="item.text"
              v-html="item.text"
            ></div>
          </v-col>
        </v-row>
      </v-container>

      <div class="mt-10 mt-md-16" v-if="team">
        <v-container>
          <div class="vinheta">
            <div
              class="d-flex align-center font-weight-regular white--text small"
            >
              <v-icon class="mr-3"> fa fa-play </v-icon>
              Conheça
            </div>

            <div class="font-weight-black white--text text-uppercase mt-4 big">
              NOSSA EQUIPE
            </div>
          </div>
        </v-container>

        <carousel
          class="team-carousel mt-5"
          :dots="false"
          :responsive="responsive"
        >
          <v-card
            :to="to"
            class="team"
            v-for="({ img, title, to }, i) in team"
            :key="i"
            tile
          >
            <img
              loading="lazy"
              :src="files + img + `?resize=1&w=600`"
              v-if="img"
              :alt="title"
            />

            <div
              :class="
                (i % 2 === 0 ? 'lighten-2' : 'lighten-3') +
                ' primary font-weight-light white--text py-12 text-uppercase text-center relative team-name'
              "
              v-if="title"
            >
              <span class="relative">{{ title }}</span>
            </div>
          </v-card>
        </carousel>
      </div>

      <v-container v-if="!item && !team">
        <v-alert color="white" class="mt-12">
          Nenhuma conteúdo cadastrado até o momento.
        </v-alert>
      </v-container>
    </div>
    <v-sheet
      v-else
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import { formatToURL } from "../utils";

export default {
  data: () => ({
    loading: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      960: {
        items: 3,
      },
      1265: {
        items: 4,
      },
    },
  }),
  computed: {
    item() {
      if (!this.$rest("about").item) return null;

      return this.$rest("about").item;
    },
    team() {
      if (!this.$rest("team").list.length) return null;

      return this.$rest("team").list.map(({ id, img, title }) => ({
        img,
        title,
        to: `/equipe/${formatToURL(title)}-${id}`,
      }));
    },
  },
  mounted() {
    this.$rest("about")
      .get({ save: (state, data) => (state.item = data) })
      .then(() => (this.loading = false));

    this.$rest("team").get();
  },
  components: {
    carousel,
  },
};
</script>

<style scoped>
.about {
  background-color: #1e1c1c;
  height: 100%;
}

.bg-img-header {
  left: 0;
  margin-top: -128px;
  max-height: 90%;
  max-height: calc(100% + 128px);
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 1;
}

.bg-img-header::after {
  background: rgb(31, 29, 29);
  background: -moz-linear-gradient(
    0deg,
    rgba(31, 29, 29, 1) 0%,
    rgba(31, 29, 29, 0.6) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(31, 29, 29, 1) 0%,
    rgba(31, 29, 29, 0.6) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(31, 29, 29, 1) 0%,
    rgba(31, 29, 29, 0.6) 100%
  );
  content: "";
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#1f1d1d",endColorstr="#1f1d1d",GradientType=1);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.bg-img-header::before {
  background: rgb(31, 29, 29);
  background: -moz-linear-gradient(
    0deg,
    rgba(31, 29, 29, 0) 0%,
    rgba(31, 29, 29, 1) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(31, 29, 29, 0) 0%,
    rgba(31, 29, 29, 1) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(31, 29, 29, 0) 0%,
    rgba(31, 29, 29, 1) 100%
  );
  content: "";
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#1f1d1d",endColorstr="#1f1d1d",GradientType=1);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.bg-img-header img {
  display: block;
  filter: blur(5px);
  max-height: 100%;
  object-fit: cover;
  -o-object-fit: cover;
  object-position: center;
  -o-object-position: center;
  width: 100%;
}

.item {
  z-index: 2;
}

.featured-img {
  height: auto;
  width: 100%;
}

.item-title {
  font-size: 28px;
  line-height: 33px;
}

.item-text {
  font-size: 16px;
  line-height: 24px;
}

.team img {
  aspect-ratio: 1 / 1;
  object-fit: cover;
  -o-object-fit: cover;
  object-position: center;
  -o-object-position: center;
  width: 100%;
}

.vinheta .small {
  font-size: 21px;
  line-height: 24px;
}

.vinheta .small .v-icon {
  background: rgb(237, 50, 55);
  background: -moz-linear-gradient(
    0deg,
    rgba(243, 116, 53, 1) 0%,
    rgba(237, 50, 55, 1) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(243, 116, 53, 1) 0%,
    rgba(237, 50, 55, 1) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(243, 116, 53, 1) 0%,
    rgba(237, 50, 55, 1) 100%
  );
  background-clip: text;
  -o-background-clip: text;
  -moz-background-clip: text;
  -webkit-background-clip: text;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f37435",endColorstr="#ed3237",GradientType=1);
  font-size: 24px;
  margin-top: -2px;
  text-fill-color: transparent;
  -o-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  -webkit-text-fill-color: transparent;
  transform: rotate(-90deg);
}

.vinheta .big {
  font-size: 28px;
}

.team-carousel img {
  filter: grayscale(100%);
}

.team-name {
  font-size: 21px;
  overflow: hidden;
}

.team-name::before {
  background-color: #ed3237;
  border-radius: 25rem;
  content: "";
  left: 50%;
  margin-left: -15px;
  margin-top: -15px;
  opacity: 0;
  padding: 15px;
  position: absolute;
  top: 50%;
  transition: padding 0.4s linear, margin 0.4s linear, top 0.4s linear,
    left 0.4s linear, opacity 0.2s linear;
}

.team:hover .team-name::before {
  padding: 100%;
  left: 0;
  margin-left: -50%;
  margin-top: -80%;
  opacity: 1;
  top: 0;
}
</style>

<style>
.team-carousel .owl-carousel {
  display: flex;
  justify-content: center;
}

@media screen and (min-width: 1264.001px) {
  .owl-carousel.owl-loaded {
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
  }
}

.team-carousel .owl-carousel .owl-nav {
  justify-content: flex-end;
  margin: 0 auto;
  padding-right: 15px;
  position: absolute;
  top: -80px;
  width: 100%;
}

.team-carousel .owl-carousel .owl-nav:not(.disabled) {
  display: flex;
}

.team-carousel .owl-carousel .owl-nav .owl-prev,
.team-carousel .owl-carousel .owl-nav .owl-next {
  background-color: #ffffff;
  font-size: 0;
  height: 40px;
  margin: 0;
  overflow: hidden;
  position: relative;
  text-indent: 200vw;
  transition: all 0.1s linear;
  white-space: nowrap;
  width: 40px;
}

.team-carousel .owl-carousel .owl-nav .owl-next {
  margin-left: 10px;
}

.team-carousel .owl-carousel .owl-nav .owl-prev:hover,
.team-carousel .owl-carousel .owl-nav .owl-next:hover {
  opacity: 0.7;
}

.team-carousel .owl-carousel .owl-nav .owl-prev::before,
.team-carousel .owl-carousel .owl-nav .owl-next::before {
  align-items: center;
  color: var(--v-primary-lighten3) !important;
  display: flex;
  font-family: "Font Awesome 5 Free";
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: 700;
  height: 100%;
  justify-content: center;
  left: 0;
  line-height: 1;
  position: absolute;
  text-indent: 0;
  text-rendering: auto;
  top: 0;
  width: 100%;
}

.team-carousel .owl-carousel .owl-nav .owl-prev:hover::before,
.team-carousel .owl-carousel .owl-nav .owl-next:hover::before {
  color: var(--v-primary-lighten2);
}

.team-carousel .owl-carousel .owl-nav .owl-prev::before {
  content: "\f053";
}

.team-carousel .owl-carousel .owl-nav .owl-next::before {
  content: "\f054";
}

@media screen and (min-width: 1200px) {
  .team-carousel .owl-carousel .owl-nav {
    max-width: 1194px !important;
  }
}
</style>
